/* global urlParams, loadingBar */

/**
 * Contains the geo coordinates of user.
 * Could also get/refresh coords
 */
var Position = {
  /**
   * Initial <code>null</code>.</br>
   * With valid location data has <code>lat</code> and <code>lng</code>.</br>
   * <code>false</code> if already tryed to get location data and faild
   */
  coords: null,
  /**
   * Contains the default location object.
   * Currently Bremen.
   * Will be overwriten if position is in url
   */
  DEFAULT: {
    /*lat: 53.4839, //Aurich
         lng: 7.5151,
         setByUrl: false*/
    lat: 53.0833333, //Bremen
    lng: 8.8,
    setByUrl: false,
  },
  /**
   * Will be set to true if user declined to be located.
   */
  _accessDenied: false,
  /**
   * Search for url Params <i>lat</i> and <i>lng</i> and set it for default.
   * @returns {undefined}
   */
  init: function () {
    //catch urlParams
    if (typeof urlParams === "undefined")
      urlParams = {
        data: null,
      };

    if (urlParams.data.lat && urlParams.data.lng) {
      this.DEFAULT = {
        lat: parseFloat(urlParams.data.lat),
        lng: parseFloat(urlParams.data.lng),
        setByUrl: true,
      };
      //set position from url to current
      this.coords = {
        lat: this.DEFAULT.lat,
        lng: this.DEFAULT.lng,
      };
    }
  },
  /**
   * Get or refresh user geo coords.
   * @param {function} callback
   * Async script. Will be called after successfull refreshing coords
   * @param {function} error
   * Async script. will be called on failing get location.
   * @returns {undefined}
   */
  refreshLocation: function (callback, error) {
    if (this._accessDenied) {
      if (typeof error === "function") error();
      return;
    }

    loadingBar.push();
    var that = this;

    navigator.geolocation.getCurrentPosition(
      function (position) {
        var coords = position.coords;
        that.coords = {
          lat: coords.latitude,
          lng: coords.longitude,
          accuracy: coords.accuracy,
          setByUrl: false,
        };
        loadingBar.pop();
        if (typeof callback === "function") callback();
      },
      function () {
        loadingBar.pop();
        that._accessDenied = true;
        that.coords = {
          lat: that.DEFAULT.lat,
          lng: that.DEFAULT.lng,
        };
        if (typeof error === "function") error();
      }
    );
  },
  /**
   * Requests Google API fro an location from an adress
   * @param {string} string
   * @param {function} success
   * Async call with <code>{lat: float, lng: float}</code>
   * @param {function} error
   * Async call.
   * @returns {undefined}
   */
  getLocationFromAdress: function (string, success, error) {
    getJSON(
      "https://maps.googleapis.com/maps/api/geocode/json?" +
        "&address=" +
        encodeURIComponent(string),
      function (response) {
        if (response.status === "OK") {
          if (typeof success === "function")
            success(response.results[0].geometry.location);
        } else {
          if (typeof error === "function") error();
        }
      }
    );
  },
  /**
   * Requests Google API so return an String from Location
   * @param {object} location
   * <code>{lat: float, lng: float}</code>
   * @param {string} type
   * Type of Adress you wish to got. Example <i>city</i>
   * @param {function} success
   * @param {function} error
   * @returns {undefined}
   */
  getAdressFromLocation: function (location, type, success, error) {
    switch (type) {
      case "city":
        type = "locality";
        break;
      default:
        console.warn("Type " + type + " not implemented");
        if (typeof error === "function") error();
        return;
    }

    getJSON(
      "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
        location.lat +
        "," +
        location.lng,
      function (result) {
        for (var i = 0, len = result.results.length; i < len; i++) {
          for (
            var j = 0, len2 = result.results[i].types.length;
            j < len2;
            j++
          ) {
            if (result.results[i].types[j] === type) {
              var locationName =
                result.results[i].formatted_address.split(",")[0];
              if (typeof success === "function") success(locationName);
              return;
            }
          }
        }
        if (typeof error === "function") error();
      }
    );
  },
};
